module.exports = __webpack_public_path__ + "static/media/cloud-music.30c90581.svg";